import { render, staticRenderFns } from "./CharacteristicStep2.vue?vue&type=template&id=755a0e17&"
import script from "./CharacteristicStep2.vue?vue&type=script&lang=js&"
export * from "./CharacteristicStep2.vue?vue&type=script&lang=js&"
import style0 from "./CharacteristicStep2.vue?vue&type=style&index=0&id=755a0e17&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports